const defaultState = () => ({
  alertsOpened: {},
  messagesOpened: {},
  feedbackRating: {
    ORTHOGRAPHY: undefined,
    RESULTS: undefined,
    DEEP: undefined,
    FALSE_POSITIVE: undefined,
    SAFETY_RECOMMENDATIONS: undefined,
    BEST_PRACTICES: undefined,
    EXPERTISE_AND_SKILLS: undefined,
    FOLLOW_UP: undefined,
    HISTORICAL_EVALUATION: undefined,
    
    CLIENT: undefined
  }
})
export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    feedbackRating: state => state.feedbackRating,
    alertsOpened: state => state.alertsOpened,
    messagesOpened: state => state.messagesOpened
  },
  mutations: {
    feedbackRating: (state, { id, input }) => {
      state.feedbackRating[id] = input
    },
    alertsOpened: (state, { id, total }) => {
      state.alertsOpened[id] = total
    },
    messagesOpened: (state, { id, total }) => {
      state.messagesOpened[id] = total
    },
    resetFeedbackRating: (state) => {
      state.feedbackRating = defaultState().feedbackRating
    }
  }
}

